import React, { useState } from 'react'

import { IconButton, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'

export interface MenuItems {
  label: string
  value: string
  handleClick?: () => void
}

interface Props {
  menuItem: MenuItems[]
  className?: 'primary' | 'secondary'
  iconclassName?: string
}

const MenuComponent: React.FC<Props> = (props:Props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const id = open ? 'popover' : undefined

  const handleClick = (event:any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        aria-describedby={id}
        onClick={handleClick}
        className={props.className}
      >
        <MoreVertIcon className={props.iconclassName} />
      </IconButton>
      <Menu
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {props.menuItem.map((item, i) => (
          <MenuItem
            key={i} value={item.value} onClick={() => {
              handleClose()
              item.handleClick && item.handleClick()
            }}
          >{item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default MenuComponent
